import { Delete, Edit, RemoveRedEyeOutlined } from "@mui/icons-material";
import {
  Avatar,
  AvatarGroup,
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { usePlayoffContext } from "../../context/PlayoffContext";

export const Group = ({ group, handleConfirmGroup, readOnly = false }) => {
  const { handleEditGroup } = usePlayoffContext();

  // useEffect(() => {
  // 	console.log("====================================");
  // 	console.log(!("products" in group));
  // 	console.log("====================================");
  // 	if (!("products" in group)) {
  // 		axiosInstance.get(`group-products/${group.id}/`).then((res) => {
  // 			console.log("====================================");
  // 			console.log(res.data);
  // 			console.log("====================================");
  // 			setGroups((prevGroups) =>
  // 				prevGroups.map((g) =>
  // 					g.id === group.id ? { ...g, products: res.data } : g
  // 				)
  // 			);
  // 		});
  // 	}
  // }, [group]);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Grid item md={4}>
      <Card>
        <CardHeader
          subheader={`Group details\n Name: ${group.name}\nCategory: ${group.product_category.length ? group.product_category[0]?.name : ""}`}
          sx={{
            "& .MuiCardHeader-subheader": {
              whiteSpace: "pre-line",
            },
          }}
        />
        <CardContent>
          <Typography variant="h6" component="div">
            Product:
          </Typography>

          <AvatarGroup
            componentsProps={{
              additionalAvatar: {
                onClick: (e) => {
                  console.log("yes");
                  handleClick(e);
                },
                sx: {
                  cursor: "pointer",
                  bgcolor: "primary.main",
                },
                title: "See all users", // optional tooltip
              },
            }}
            sx={{
              justifyContent: "center",
            }}
            total={group.products?.length}
          >
            {group.products?.slice(0, 4).map((product, i) => (
              <Avatar
                key={`group-pro-${i}`}
                alt={product.name}
                src={product?.image?.file}
              />
            ))}
          </AvatarGroup>

          <Typography variant="h6" component="div">
            Qty Limit:
            {group.qty_limit}
          </Typography>
        </CardContent>
        {!readOnly && (
          <CardActions disableSpacing>
            <IconButton
              aria-label="add to favorites"
              onClick={() => {
                // console.log("yes");
                handleEditGroup(group.id);
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              aria-label="delete product"
              onClick={() => {
                handleConfirmGroup(group, true);
                // setProducts(new_products)
              }}
            >
              <Delete color="secondary" />
            </IconButton>
			 {group.products?.length > 0 && (
                  <IconButton onClick={handleClick} sx={{ marginLeft: "auto" }}>
                    <RemoveRedEyeOutlined />
                  </IconButton>
                )}
          </CardActions>
        )}
      </Card>
      <Popover
        id={`id-${group.id}`}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <CardContent>
          <Typography paragraph>Products:</Typography>
          <Box>
            {group.products?.map((product, i) => {
              return (
                <Stack
                  key={`playoff-group-${i}`}
                  direction="row"
                  alignItems="center"
                  gap={1}
                >
                  <Avatar alt={product.name} src={product?.image?.file} />
                  <Typography
                    paragraph
                    sx={{
                      marginBottom: 0,
                    }}
                  >
                    {product.name}
                  </Typography>
                </Stack>
              );
            })}
          </Box>
        </CardContent>
      </Popover>
    </Grid>
  );
};
